import { Locale } from '../../i18n/types';

interface Props {
  lore: Locale['lore'];
}

export default function LoreTab({ lore }: Props) {
  return (
    <div>
      <div className="mb-4">
        <h2 className="tab-page-title">
          {lore.heading}
        </h2>
        <div className="d-flex flex-column gap-3">
          {lore.paragraphs.map((p, i) => (
            <p
              key={i}
              className="text-body-default"
              style={{ marginBottom: 0 }}
              dangerouslySetInnerHTML={{
                __html: p.replace('Broom Wagon', '<span class="brand-highlight">Broom Wagon</span>'),
              }}
            />
          ))}
        </div>
      </div>

      <div className="mb-4 d-flex flex-column align-items-center">
        <img
          src="/jef-planckaert-dans-le-camion-balais-tour-de-france-1963.jpg"
          alt="Jef Planckaert in the broom wagon, Tour de France 1963"
          style={{
            width: '100%',
            maxHeight: '45vh',
            objectFit: 'contain',
          }}
        />
        <div className="text-center image-caption mt-2">
          Jef Planckaert, Tour de France (1963)
        </div>
      </div>

      <div className="mt-4 pt-3 divider-subtle">
        <div className="mb-2 label-uppercase-small">
          {lore.linksLabel}
        </div>
        <div className="d-flex flex-column gap-2">
          <a
            href="https://piedmontvelosports.blogspot.com/2012/12/the-broom-wagon.html"
            target="_blank"
            rel="noreferrer"
            className="link-subtle"
          >
            <i className="bi bi-link-45deg me-2"></i> The Broom Wagon (Piedmont Velo Sports)
          </a>
          <a
            href="https://en.wikipedia.org/wiki/Broom_wagon"
            target="_blank"
            rel="noreferrer"
            className="link-subtle"
          >
            <i className="bi bi-wikipedia me-2"></i> Broom wagon (Wikipedia)
          </a>
        </div>
      </div>
    </div>
  );
}
